jQuery(document).ready(function ($) {
    var elt = $("[for='f2019910152356_52214472']").closest(".form-group");
    elt.find(".col-sm-3")
    .removeClass("col-sm-3")
    .css('width','80%')
    .css('float','left');

    elt.find(".col-sm-6").removeClass("col-sm-6")
    .removeClass("col-xs-12")
    .css('float','left');
});
